import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { PartnershipDialogComponent } from 'app/modules/partnership-dialog/partnership-dialog.component';
import { ApplicationService } from 'app/services/application.service';

@Component({
  selector: 'app-partnership-info',
  standalone: true,
  imports: [CommonModule,TranslateModule],
  templateUrl: './partnership-info.component.html',
})
export class PartnershipInfoComponent {
  @Input() partnershipData: any;
  @Output() openPartnershipDialog: any = new EventEmitter<any>();
  
  removeHtmlTags(text: string) {
    const updatedText = new DOMParser().parseFromString(text, 'text/html');
    return updatedText.body.textContent || '';
  }

  emitPartnershipDialog(data: any) {
    this.openPartnershipDialog.emit(data);
  }
}
